<script>
import bem from '@/utils/bem';
import { mapActions, mapState, mapGetters } from 'vuex';
import UserAddressForm from '@/components/forms/User-address-form.vue';
import constants from '@/constants';

const b = bem('user-info-page');
const { states } = constants;
export default {
  data() {
    return {
      states,
      userId: 0,
    };
  },
  mounted() {
    const { id } = this.$route.params;
    this.getBilling({ id });
    this.getShipping({ id });
    this.getUserById(id);
    this.userId = Number(id);
  },
  components: {
    UserAddressForm,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getBilling: 'users/getUserBillingInfo',
      getShipping: 'users/getUserShippingInfo',
      getUserById: 'users/getUserById',
    }),
  },
  computed: {
    ...mapState({
      billingInfo: (state) => state.users.userBillingInfo,
      shippingInfo: (state) => state.users.userShippingInfo,
      currentUser: (state) => state.users.currentUser,
    }),
    ...mapGetters({
      isCompanyUser: 'auth/isCompanyUser',
    }),
    userEmail() {
      return this.currentUser && this.currentUser.email
        ? this.currentUser.email
        : '';
    },
    userHasCompany() {
      return this.currentUser && this.currentUser.companyId;
    },
    isCompanyUserOrHasCompany() {
      return this.isCompanyUser || this.userHasCompany;
    },
  },
};
</script>

<template>
  <div :class="b()">
    <UserAddressForm
        :is-billing="true"
        :title="isCompanyUserOrHasCompany ? 'User address' : 'Billing address'"
        :states="states"
        :address-info="billingInfo"
        :user-id="userId"
        :is-company-user="isCompanyUserOrHasCompany"
        :user-email="userEmail"
    />
    <UserAddressForm
        v-if="!isCompanyUserOrHasCompany"
        :is-billing="false"
        title="Shipping address"
        :states="states"
        :address-info="shippingInfo"
        :user-id="userId"
        :is-company-user="isCompanyUserOrHasCompany"
    />
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
